import { Customer } from '@adapters/bigcommerce/types/customer';
import crypto from 'crypto';
import TagManager from 'react-gtm-module';

const pageView = ({
  locale,
  path,
  route,
  customer,
}: {
  locale?: string;
  path: string;
  route: string;
  customer: Customer | null;
}) => {
  if (route !== '/auth/signin') return; // TODO revist after launch to ensure other pages are accurately tracked

  const user = customer
    ? {
        user_id: crypto
          .createHash('sha256')
          .update(customer.entityId.toString())
          .digest('hex'),
        hashed_email_address: crypto
          .createHash('sha256')
          .update(customer.email)
          .digest('hex'),
        login_state: 'true',
        preferred_language:
          customer.attributes.preferredLanguage?.value === 'fr' ? 'FR' : 'EN',
        newsletter_subscribed: !!customer.attributes.emailConsent?.value,
      }
    : {
        login_state: 'false',
      };

  const pageType =
    route === '/auth/signin' ? 'interstitial before checkout' : 'storefront';

  // UCS001 - Page load
  TagManager.dataLayer({ dataLayer: { ecommerce: null } }); // Clear ecommerce object

  TagManager.dataLayer({
    dataLayer: {
      event: 'pageview',
      event_name: 'page_view',
      page: {
        language: locale,
        path: path.split('?')[0],
        environment: process.env.NEXT_PUBLIC_DATADOG_ENV,
        page_type: pageType,
      },
      user,
    },
  });
};

const clickGuest = () => {
  // UCS002 - Click CTA Guest Checkout
  TagManager.dataLayer({ dataLayer: { ecommerce: null } }); // Clear ecommerce object

  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_name: 'click_guest_checkout',
    },
  });
};

const clickSignIn = () => {
  // UCS003 - Click CTA Sign In And Checkout
  TagManager.dataLayer({ dataLayer: { ecommerce: null } }); // Clear ecommerce object

  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_name: 'click_sign_in_checkout',
    },
  });
};

const clickSignUp = () => {
  // UCS004 - Click CTA Sign Up
  TagManager.dataLayer({ dataLayer: { ecommerce: null } }); // Clear ecommerce object

  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_name: 'click_sign_up_checkout',
    },
  });
};

const accountLoginBeforeCheckout = () => {
  // UCS005 - Account login (before checkout)
  TagManager.dataLayer({ dataLayer: { ecommerce: null } }); // Clear ecommerce object

  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_name: 'sign_in',
      interaction: {
        interaction_location: 'before checkout',
      },
    },
  });
};

const accountLoginFromStorefront = () => {
  // UCS006 - Account login (storefront)
  TagManager.dataLayer({ dataLayer: { ecommerce: null } }); // Clear ecommerce object

  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_name: 'sign_in',
      interaction: {
        interaction_location: 'storefront',
      },
    },
  });
};

const accountCreationBeforeCheckout = () => {
  // UCS007 - Account creation (before checkout)
  TagManager.dataLayer({ dataLayer: { ecommerce: null } }); // Clear ecommerce object

  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_name: 'sign_up',
      interaction: {
        interaction_location: 'before checkout',
      },
    },
  });
};

// UCS008 handled in checkout

// UCS009 handled in checkout

const accountCreationFromStorefront = () => {
  // UCS010 - Account creation (storefront)
  TagManager.dataLayer({ dataLayer: { ecommerce: null } }); // Clear ecommerce object

  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_name: 'sign_up',
      interaction: {
        interaction_location: 'storefront',
      },
    },
  });
};

export default {
  pageView,
  clickGuest,
  clickSignIn,
  clickSignUp,
  accountLoginBeforeCheckout,
  accountLoginFromStorefront,
  accountCreationBeforeCheckout,
  accountCreationFromStorefront,
};
